<template>
    <div id="screen" class="mainframe">
        <vue-scroll>
            <user-info :aircraft="aircraftName" :procedures="procedures.length" @close-screen="screenOff"/>
            <div class="justify-start" style="display: flex; max-width: 100%;">
                <v-btn-toggle
                    style="max-width: 100%; display: flex; flex-wrap: wrap"
                    color="secondary"
                    light
                    v-model="selectedTourGroupId"
                >
                    <v-btn x-small v-for="group in tourGroups " :key="group.id" :value="group.id"
                           style="margin: .5em;" class="rounded custom-btn" :disabled="selectedTourGroupId === group.id">
                        {{ group.title }}
                    </v-btn>
                    <v-btn x-small value="none" style="margin: .5em" class="rounded custom-btn" :disabled="selectedTourGroupId === 'none'">
                        ALL
                    </v-btn>
                </v-btn-toggle>

            </div>

            <v-timeline dense>
                <v-slide-x-reverse-transition
                    group
                    hide-on-leave
                >
                    <v-timeline-item
                        v-for="(procedure, index) in filteredProcedures"
                        :key="index"
                        small
                        fill-dot
                        @click="startSlider(procedure)"
                    >

                        <v-list-item
                            @click="startSlider(procedure)"
                            class="list-item"
                        >
                            <v-list-item-content>
                                <v-list-item-title v-text="procedure.name"
                                                   style="text-align: left; font-weight: bold; color: rgb(13, 71, 161)"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-timeline-item>
                </v-slide-x-reverse-transition>
            </v-timeline>

        </vue-scroll>
    </div>
</template>

<script>

import UserInfo from "./UserInfo"
import {ExamMode, procedureTeacher} from "../modules/ProcedureTeacher";

export default {
    props: {
        procedures: {
            type: Array,
            required: true
        }
    },
    $emit: ['screenSwitch', 'startSlider'],
    data() {
        return {
            selectedTourGroupId: 'none',
        }
    },
    computed: {
        aircraftName() {
            return this.$store.state.cockpit.aircraftName
        },
        isCompleted() {
            return procedure => this.$store.state.completed_procedures.find(p => p.procedure === procedure.name)
        },
        blindExamMode() {
            return procedureTeacher.examMode === ExamMode.blind;
        },
        tourGroups() {
            return [...this.$store.state.cockpit.tourGroups];
        },
        filteredProcedures() {
            if (this.selectedTourGroupId === 'none') {
                const clone_procedures = [...this.procedures]
                return clone_procedures.sort((a, b) => a.title.localeCompare(b.title));
            } else {
                return this.procedures.filter(procedure => procedure.tour_group_id === this.selectedTourGroupId);
            }
        }
    },
    methods: {
        async screenOff() {
            await this.$emit("screenSwitch", {value: false, procedure: procedureTeacher.activeProcedure});
        },
        async startSlider(procedure) {
            await procedureTeacher.endProcedure()
            await this.$emit("startSlider", procedure);
        },
    },
    components: {
        UserInfo,
    },
};
</script>

<style scoped lang="less">
@import "../assets/lufthansacolors";

.theme--light.v-btn.v-btn--has-bg {
    background-color: @lh-skyblue1;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: @lh-yellow !important;;
}

.mainframe {
    position: fixed;
    height: 90vh;
    width: 90vw;
    top: 5vh;
    left: 5vw;
    box-shadow: 20px 20px 20px 20px rgba(0, 0, 0, 0.5);
    border: 4px solid rgb(94, 141, 168);
    border-radius: 10px;
    /*background-image: linear-gradient(to bottom, #dbecff, #91a9c5);*/
    font-family: Roboto, sans-serif;
    overflow: hidden;
    background-color: white;
}

.mainframe .title {
    display: flex;
    flex-direction: row;

    h3 {
        padding: 1em;
        display: inline-block;
        flex-grow: 1;
    }
}

.mainframe .title a {
    text-decoration: none;
}

.mainframe .title a button {
    color: white;
    line-height: inherit;
    margin: auto 0;
}

.mainframe .title h3 {
    margin-right: .5em;
    -webkit-text-stroke: 1px @lh-skyblue1; /* width and color */
    color: #0e0404;
}

.mainframe .list-item {

    padding: 0 2em;

}

.blind_exam_button {
    margin-right: 15px;
}

</style>
